<template>

    <footer class="footer">
        <!-- Footer Top -->
        <div class="footer-top aos aos-init aos-animate" data-aos="fade-down">
            <div class="container">
                <div class="row justify-content-between">
                    <div class="col-lg-8">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-6">
                                <div class="footer-widget footer-menu">
                                    <div class="logo mb-35">
                                        <router-link :to="{ name: 'HomePage'}">
                                            <!--<img src="../../../../../assets/images/logo/logo-white.png" alt="logo" />-->
                                            <img :src="companyLogo" :alt="companyName" />
                                        </router-link>
                                    </div>
                                    <div class="footer-text mb-50 mt-4 pr-50">
                                        <p>
                                            {{FooterLogoDescription}}
                                        </p>
                                    </div>
                                    <div class="footer-social-widget mt-4" >
                                        <SocialMediaIconComponent></SocialMediaIconComponent>
                                        </div>
                                    </div>
                                </div>
                            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-6">
                                <div class="footer-widget footer-menu mb-30 pl-60">
                                    <h5 class="footer-title">{{$t('StoreFront.Links')}}</h5>

                                    <ul>
                                        <li v-for="link in footerNavLinks">
                                            <router-link class="nav-link" :to="{ name: link.routeUrl,params:link.params}">{{link.displayText}}</router-link>
                                        </li>
                                    </ul>

                                </div>
                            </div>
                            <!--<div class="col-lg-4 col-md-6">-->
                            <!-- Footer Widget -->
                            <!--<div class="footer-widget footer-menu">
        <h5 class="footer-title">About Company</h5>
        <ul>
            <li>
                <router-link :to="{ name: 'Aboutus' }">
                    Our Company
                </router-link>

            </li>
            <li>
                <a href="javascript:void(0)">Shop Toyota</a>
            </li>
            <li>
                <a href="javascript:void(0)">Dreamsrentals USA</a>
            </li>
            <li>
                <a href="javascript:void(0)">Dreamsrentals Worldwide</a>
            </li>
            <li>
                <a href="javascript:void(0)">Dreamsrental Category</a>
            </li>
        </ul>
    </div>-->
                            <!-- /Footer Widget -->
                            <!--</div>
    <div class="col-lg-4 col-md-6">-->
                            <!-- Footer Widget -->
                            <!--<div class="footer-widget footer-menu">
        <h5 class="footer-title">Vehicles Type</h5>
        <ul>
            <li>
                <a href="javascript:void(0)">All  Vehicles</a>
            </li>
            <li>
                <a href="javascript:void(0)">SUVs</a>
            </li>
            <li>
                <a href="javascript:void(0)">Trucks</a>
            </li>
            <li>
                <a href="javascript:void(0)">Carts</a>
            </li>
            <li>
                <a href="javascript:void(0)">Crossovers</a>
            </li>
        </ul>
    </div>-->
                            <!-- /Footer Widget -->
                            <!--</div>
    <div class="col-lg-4 col-md-6">-->
                            <!-- Footer Widget -->
                            <!--<div class="footer-widget footer-menu">
        <h5 class="footer-title">Quick links</h5>
        <ul>

            <li>
                <a href="javascript:void(0)">Champaigns</a>
            </li>
            <li>
                <a href="javascript:void(0)">Dreamsrental Dealers</a>
            </li>
            <li>
                <a href="javascript:void(0)">Deals and Incentive</a>
            </li>
            <li>
                <a href="javascript:void(0)">Financial Services</a>
            </li>
        </ul>
    </div>-->
                            <!-- /Footer Widget -->
                            <!--</div>-->
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="footer-contact footer-widget">
                            <h5 class="footer-title">Contact Info</h5>
                            <div class="footer-contact-info">
                                <div class="footer-address">
                                    <span><i class="feather-phone-call"></i></span>
                                    <div class="addr-info">
                                        <p><a href="tel:{{OurPhone}}">{{OurPhone}}</a></p>
                                    </div>
                                </div>
                                <div class="footer-address">
                                    <span style=" background: #075e54;"><i class="fab fa-whatsapp"></i></span>
                                    <div class="addr-info">
                                        <p><a href="javascript:void(0);">{{OurPhone}}</a></p>
                                    </div>
                                </div>
                                <div class="footer-address last">
                                    <span><i class="feather-mail"></i></span>
                                    <div class="addr-info">
                                        <a href="mailto:{{OurEmail}}">{{OurEmail}}</a>
                                    </div>
                                </div>
                                <div class="update-form">
                                    <!--<form action="#">
            <span><i class="feather-mail"></i></span>
            <input type="email" class="form-control" placeholder="Enter You Email Here">
            <button type="submit" class="btn btn-subscribe"><span><i class="feather-send"></i></span></button>
        </form>-->

                                    <newsletter></newsletter>
                                </div>
                            </div>
                            <div class="footer-social-widget">
                                <!--<SocialMediaIconComponent></SocialMediaIconComponent>-->
                                <!--<ul class="nav-social">
                                    <li>
                                        <a href="javascript:void(0)"><i class="fa-brands fa-facebook-f fa-facebook fi-icon"></i></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)"><i class="fab fa-instagram fi-icon"></i></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)"><i class="fab fa-behance fi-icon"></i></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)"><i class="fab fa-twitter fi-icon"></i> </a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)"><i class="fab fa-linkedin fi-icon"></i></a>
                                    </li>
                                </ul>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /Footer Top -->
        <!-- Footer Bottom -->
        <div class="footer-bottom">
            <div class="container">
                <!-- Copyright -->
                <div class="copyright">
                    <div class="row align-items-center">
                        <div class="col-md-6">
                            <div class="copyright-text">
                                <p v-html="Copyrights"></p>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <!-- Copyright Menu -->
                            <div class="copyright-menu">
                                <div class="vistors-details">
                                    <ul class="d-flex">
                                        <li><a style=" cursor: default; "><img class="img-fluid" src="../../../../../assets/Theme/GolfCart/img/icons/paypal.svg" alt="Paypal"></a></li>
                                        <li><a style=" cursor: default; "><img class="img-fluid" src="../../../../../assets/Theme/GolfCart/img/icons/visa.svg" alt="Visa"></a></li>
                                        <li><a style=" cursor: default; "><img class="img-fluid" src="../../../../../assets/Theme/GolfCart/img/icons/master.svg" alt="Master"></a></li>
                                        <li><a style=" cursor: default; "><img class="img-fluid" src="../../../../../assets/Theme/GolfCart/img/icons/applegpay.svg" alt="applegpay"></a></li>
                                    </ul>
                                </div>
                            </div>
                            <!-- /Copyright Menu -->
                        </div>
                    </div>
                </div>
                <!-- /Copyright -->
            </div>
        </div>
        <!-- /Footer Bottom -->
    </footer>
    <!-- /Footer -->

</template>

<script>
    import SocialMediaIconComponent from '@/views/SocialMediaIcons/socialMediaIcons.vue'
    import newsletter from '@/views/NewsLetter/newsletter.vue'
    export default {
        name: 'FooterVue',
        props: ["footerNavLinks", "serviceLinks", "FooterLogoDescription", "OurAddress", "OurEmail", "OurPhone", "Copyrights","secondaryLogoLink"],
        components: {
            SocialMediaIconComponent, newsletter
        },
        data() {
            return {
                companyLogo: '',
                companyName: ''
            }
        },
        created() {
            this.getCompanyLogo();
            this.companyName = localStorage.getItem('companyName')
        },
        methods: {
            getCompanyLogo() {
                let logoUrl = localStorage.getItem('companyLogo');
                this.companyLogo = (this.$filters.IsNull(logoUrl, 'null') == 'null') ? require('../../../../../assets/images/logo/default-logo.png') : logoUrl;
            }
        }

    }
</script>